import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JuniorPilotComponent } from './junior-pilot.component';
import { TooltipDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { TableSliderModule } from '@common/components/feature-part/table-slider/table-slider.module';
import { JuniorPilotItemModule } from './junior-pilot-item/junior-pilot-item.module';

@NgModule({
  declarations: [JuniorPilotComponent],
  imports: [CommonModule, StaticMsgModule, TooltipDirectiveModule, TableSliderModule, JuniorPilotItemModule],
  exports: [JuniorPilotComponent],
})
export class JuniorPilotModule {}
